import { GenericStatusByCall } from '../../enums/status-by-call';
import { BasePagedResponse, PagedResponse, SimplePagedResponse } from '../../models/common-response-types';
import { Company } from '../../models/company';
import {
  AvailableIndexesResponse,
  CompanyLogoAndNameState,
  DividendPayerData,
  Earning,
  EpicMoversRequestAndResponse,
  ETF,
  GapperResponse,
  HighGrowthCompanyData,
  IPO,
  NewStockData,
  PageableFilterRequest,
  PopularStock,
  RatiosResponse,
  Sector,
  SectorDetail,
  Split,
  SymbolStatementApiResponse,
  TopGainersAndLosersQueryOption,
  Week52HighLowResponse,
  Week52HighLowTopListResponse,
} from '../../models/fundamental/types';
import { StockDescriptor } from '../../models/stock-descriptor';
import { SymbolKeyStat } from '../../models/symbol-key-stat';
import { DynamicFilterType } from '../../services/filter/types';
import { TypedObject } from '../../util/types';

export type GetSectorsResponse = Sector & {symbolUniverseSymbolCount: number};

export interface FundamentalState {
  stockQuery: string;
  limit: number;
  stockResults: StockDescriptor[];
  symbol: string;
  keyStats: SymbolKeyStat[];
  // TODO: Stop using companies for getting CompanyName. Take it from companyLogoAndName
  companies: Company[];
  // TODO: Delete after merging ART-1918 and use getCompanyLogoAndName for both mobile and web
  logosBase64: TypedObject<string>;
  companyLogoAndName: TypedObject<CompanyLogoAndNameState>;
  error: any;
  errorsLog: string[];
  popularStocks: PopularStock[];
  newStocks: NewStockData[];
  dividendPayers: PagedResponse<DividendPayerData>;
  highGrowthCompanies: PagedResponse<HighGrowthCompanyData>;
  sectors: Sector[];
  sectorDetails: SectorDetail;
  /**
   * @deprecated please use epicMoversData.params instead
   */
  topGainersAndLosersFilterValues: {
    minValue: number;
    maxValue: number;
  };
  availableIndexes: AvailableIndexesResponse[];
  marketIndexes: [];
  topLosersLastQuery?: TopGainersAndLosersQueryOption;
  IPOs: IPO[];
  earningsSearchResponse: PagedResponse<Earning>;
  splits: Split[];
  statusByCall: GenericStatusByCall<FundamentalCall>;
  ETFData: BasePagedResponse<ETF>;
  statementsData: SymbolStatementApiResponse;
  gappersData: SimplePagedResponse<GapperResponse>;
  week52HighLow: SimplePagedResponse<Week52HighLowResponse>;
  week52HighLowTopList: Week52HighLowTopListResponse;
  ratiosData: RatiosResponse;
  epicMoversData: EpicMoversRequestAndResponse;
}

export type SearchEarningsPayload = PageableFilterRequest & {
  symbols?: string[];
  startDate?: string | Date;
  endDate?: string | Date;
};

export type SearchStockPayload = {
  limit: number;
  query: string;
  params: DynamicFilterType;
};

export enum FundamentalCall {
  getPopularStocks,
  getNewStocks,
  getDividendPayers,
  getHighGrowthCompanies,
  getSectors,
  getSectorDetails,
  getTopGainers,
  getTopLosers,
  getIPOs,
  searchEarnings,
  getSplits,
  getCompanyLogoAndName,
  searchStocks,
  getMarketIndexes,
  getETFs,
  getETFDetails,
  getStatements,
  getStatementsCashFlow,
  getStatementsBalanceSheet,
  getStatementsIncome,
  getWeek52HighLow,
  getWeek52HighLowTopList,
  getGappers,
  getGappersCount,
  getAllRatios,
  getRatiosLiquidityAndSolvency,
  getRatiosProfitability,
  getRatiosValuation,
  getEpicMovers,
  getAvailableIndexes,
}

export enum SectorEnum {
  CommunicationsServices = 'Communication Services',
  HealthCare = 'Health Care',
  ConsumerStaples = 'Consumer Staples',
  Technology = 'Technology',
  Utilities = 'Utilities',
  ConsumerDiscretionary = 'Consumer Discretionary',
  Financials = 'Financials',
  Materials = 'Materials',
  RealEstate = 'Real Estate',
  Industrials = 'Industrials',
  Energy = 'Energy',
  ETFs = 'ETFs',
  Gappers = 'Gappers',
}
